import { FC } from 'react';

import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';

import locales from './locales';

interface AlertBeforeDeleteModalProps {
  description: string;
  loading: boolean;
  hideModal: () => void;
  onSubmit: () => void;
  title: string;
}

const AlertBeforeDeleteModal: FC<AlertBeforeDeleteModalProps> = ({
  description,
  hideModal,
  loading,
  onSubmit,
  title,
}) => {
  const onConfirm = async () => {
    try {
      await onSubmit();
      hideModal();
    } catch {
      // Error handled by useErrorHandledMutation
    }
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Title>{title}</SunshineModal.Title>
        <Text>{description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button
          isDisabled={loading}
          onClick={hideModal}
          variant="inline-secondary"
        >
          {locales.cancel}
        </Button>

        <Button isLoading={loading} onClick={onConfirm}>
          {locales.delete}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default AlertBeforeDeleteModal;
